<template>
<div class="page-title">
    <div class="title">
        <h3>Users</h3>
        <div class="actions">
            <el-button class="white-btn" @click="adddrawer = true" size="large" v-if="authuser!=null && authuser.permissions.users.add"   >Add User</el-button>
        </div>

    </div>
    <div class="filters">
        <el-form
            label-position="top"
        >
            <el-row>
                <el-col :span="2">
                    <el-form-item label="Status">
                        <el-select v-model="form.status"  placeholder="Select" size="small" >
                            <el-option
                                v-for="item in statuses"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-form-item class="ml-2" label="Department">
                        <el-select v-model="form.department"  placeholder="Select" size="small" clearable>
                            <el-option
                                v-for="item in departments"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-form-item class="ml-2" label="Designation">
                        <el-select v-model="form.designation"  placeholder="Select" size="small" clearable>
                            <el-option
                                v-for="item in designations"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="2">
                    <el-form-item class="ml-2" label="View Type">
                        <el-select v-model="form.view"  placeholder="Select" size="small" clearable>
                            <el-option
                                v-for="item in views"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="3">
                    <el-form-item class="ml-2" label=" .">
                    <el-button @click="getlist()"  type="primary" size="small"  round >Apply Filters</el-button>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-input v-model="filterText" placeholder="Filter keyword" />
                </el-col>

            </el-row>



        </el-form>



    </div>
</div>

    <div class="users-list" v-if="!loading">
        <el-tree
            ref="treeRef"
            :data="users"
            node-key="id"
            :expand-on-click-node="false"
            :filter-node-method="filterNode"
            :default-expanded-keys="expandedKeys"
            @node-expand="handleExpand"
            @node-collapse="handleCollapse"
        >
            <template #default="{ node, data }">
                <users-list-card  :user="data" :users="allusers" :destinations="destinations" :destinationtypes="destinationtypes" :authuser="authuser" :departments="departments" :designations="designations" :roles="roles" :key="data.id" @saved="getlist()"></users-list-card>

            </template>
        </el-tree>
       </div>
    <div v-else>
        <el-card class="box-card mt-2 booking-list-box" v-for="i in 7" :key="i">
            <el-skeleton :rows="1" animated />
        </el-card>

    </div>

    <el-drawer v-model="adddrawer" direction="rtl">
        <template #header>
            <h4>Add User</h4>
        </template>
        <template #default>
            <div>


                <el-form
                    label-position="top"
                    ref="ruleFormRef"
                    :model="addform"
                    status-icon
                    :rules="rules"
                >
                    <el-row>


                        <el-col :span="12">
                            <el-form-item label="Name" prop="name">

                                <el-input  v-model="addform.name"  placeholder="Enter Name" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Email" class="ml-2" prop="email">
                                <el-input   v-model="addform.email"   placeholder="Enter Email" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Phone"  prop="mobile">
                                <el-input   v-model="addform.mobile"  placeholder="Enter Phone" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Password" class="ml-2" prop="password">
                                <el-input   v-model="addform.password"  placeholder="Enter New Password" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Department"   prop="department">
                                <el-select v-model="addform.department" @change="departchange()"  placeholder="Select"  style="width:100%" >
                                    <el-option
                                        v-for="item in departments"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item class="ml-2" label="Designation"   prop="designation">
                                <el-select v-model="addform.designation" @change="rolechange()"  placeholder="Select"  style="width:100%" :disabled="form.designation=='admin'">
                                    <el-option
                                        v-for="item in designations"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="addform.designation!='management' && addform.designation!='manager' ">
                            <el-form-item label="Under Working"   prop="underworking">
                                <el-select v-model="addform.underworking"  placeholder="Select"  style="width:100%" >
                                    <el-option
                                        v-for="item in underworkings"
                                        :key="item.id"
                                        :label="item.name+' ('+item.designation+')'"
                                        :value="item.id"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item class="ml-2" label="DOJ"   prop="doj">
                                <el-date-picker
                                    v-model="addform.doj"
                                    type="date"
                                    placeholder="Pick a Date"
                                    format="DD/MMM/YYYY"
                                    value-format="YYYY-MM-DD"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" >
                            <el-form-item label="Services" class="text-bold" >
                                <div>
                                    <el-checkbox v-model="addform.package_manage" label="Package" :true-label="1" :false-label="0"  size="large" />
                                    <el-checkbox v-model="addform.flight_manage" label="Flight" :true-label="1" :false-label="0"  size="large" />
                                    <el-checkbox v-model="addform.hotel_manage" label="Hotel" :true-label="1" :false-label="0"  size="large" />
                                    <el-checkbox v-model="addform.visa_manage" label="Visa" :true-label="1" :false-label="0"  size="large" />
                                    <el-checkbox v-model="addform.cruise_manage" label="Cruise" :true-label="1" :false-label="0"  size="large" />

                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="addformerrors!=null">
                            <el-alert :title="geterror()" type="error" effect="dark"  :closable="false" />

                        </el-col>

                    </el-row>



                </el-form>
            </div>
        </template>
        <template #footer>
            <div style="flex: auto">
                <el-button type="primary" @click="adddrawer = false">Cancel</el-button>
                <el-button type="primary" @click="submitForm()">Save</el-button>
            </div>
        </template>
    </el-drawer>
</template>
<style>

</style>
<script>
import {
    ElInput,
    ElTree,
    ElText,
    ElSpace,
    ElSelect,
    ElOption,
    ElDatePicker,
    ElFormItem,
    ElForm,
    ElCol,
    ElRow,
    ElButton,
    ElCard,
    ElTag,
    ElAvatar,
    ElDivider,
    ElSkeleton,
    ElCheckbox, ElDrawer, ElMessage,ElLoading,ElAlert
} from 'element-plus'
import 'element-plus/dist/index.css'
import moment from 'moment'
import { nextTick } from 'vue'

let loadingInstance = null;


export default {
    name: "BookingList",
    components: { ElCheckbox,ElAlert,ElInput,ElDrawer,ElTree,ElText,ElSpace,ElSelect,ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton },
    data() {
        return {
            filterText:'',
            loading: true,
            addloading: false,
            adddrawer:false,
            expandedKeys: [1],
            form:{
                status:1,
                designation:'',
                department:'',
                view:'tree'
            },
            addform:{
                name : "",
                email:"",
                mobile:"",
                password:"",
                department:"",
                designation:"",
                underworking:null,
                package_manage:0,
                flight_manage:0,
                hotel_manage:0,
                visa_manage:0,
                cruise_manage:0,
                doj:null,

            },
            underworkings:[],
            rules:{
                name: [{ required: true, trigger: 'change', message:'' }],
                email: [{ required: true, trigger: 'change', message:'' }],
                mobile: [{ required: true, trigger: 'change', message:'' }],
                department: [{ required: true, trigger: 'change', message:'' }],
                designation: [{ required: true, trigger: 'change', message:'' }],
                underworking: [{ required: true, trigger: 'change', message:'' }],
                doj: [{ required: true, trigger: 'change', message:'' }],
            },
            statuses:[
                {
                    value:1,
                    label:'Active'
                },
                {
                    value:0,
                    label:'InActive'
                }
            ],

            views:[
                {
                    value:'tree',
                    label:'Tree'
                },
                {
                    value:'list',
                    label:'List'
                }
            ],
            designations:[
                {
                    value:'Management',
                    label:'Management'
                },
                {
                    value:'Manager',
                    label:'Manager'
                },
                {
                    value:'Tl',
                    label:'Tl'
                },
                {
                    value:'SME',
                    label:'SME'
                },
                {
                    value:'Agent',
                    label:'Agent'
                }

            ],
            departments:[
                {
                    value:'Account',
                    label:'Account'
                },
                {
                    value:'Operation',
                    label:'Operation'
                },
                {
                    value:'QC',
                    label:'QC'
                },
                {
                    value:'Sales',
                    label:'Sales'
                },
                {
                    value:'HR',
                    label:'HR'
                }
            ],
            users:[],
            authuser:null,
            underusers:[],
            addformerrors:null,
            allusers:[],
            destinationtypes:[],
            destinations:[]
        }
    },
    mounted() {
        this.getlist();
    },
    methods: {
        handleExpand(node) {
            if (!this.expandedKeys.includes(node.id)) {
                this.expandedKeys.push(node.id)
            }
        },
        handleCollapse(node) {
            this.expandedKeys = this.expandedKeys.filter(id => id !== node.id)
        },
        getlist() {
           // this.loading=true;
            let currentObj = this;


            axios.post('/user/getlist',this.form).then(function (response) {
                currentObj.users=response.data.users;
                currentObj.authuser=response.data.authuser;
                currentObj.designations=response.data.designations;
                currentObj.departments=response.data.departments;
                currentObj.destinationtypes=response.data.destinationtypes;
                currentObj.destinations=response.data.destinations;
                currentObj.loading=false;
                currentObj.allusers=response.data.allusers;
                    if(currentObj.loading!=true) {
                        currentObj.$refs.treeRef.filter(currentObj.filterText);

                    }

            })
                .catch(function (error) {
                    currentObj.loading=false;
                });
        },
        openbooking(link){
            window.open(link, "_blank", "width="+screen.availWidth+",height="+screen.availHeight)

        },
        filterNode (value,data) {
            if (!value) return true
            return data.name.includes(value) || data.email.includes(value) || data.mobile.includes(value)
        },
        rolechange(){



            if(this.addform.designation=="management" || this.addform.designation=="manager"){
                this.addform.underworking=null;
            }
            else{
                this.addform.underworking="";
            }

            this.departchange();


        },
        departchange(){

            if(this.addform.designation=="manager"){
                this.underworkings=[];
            }
            else if(this.addform.designation=="tl"){
                this.underworkings=this.allusers.filter(item => (( item.designation=="manager") && (item.department==this.addform.department)));
            }
            else if(this.addform.designation=="sme"){
                this.underworkings=this.allusers.filter(item => ((item.designation=="manager" || item.designation=="tl") && (item.department==this.addform.department)));
            }
            else if(this.addform.designation=="agent"){
                this.underworkings=this.allusers.filter(item => (( item.designation=="manager" || item.designation=="tl" || item.designation=="sme") && (item.department==this.addform.department)));
            }
            else{
                this.underworkings=[];
            }


        },
        submitForm(){
            this.addformerrors=null;
            var formEl=this.$refs.ruleFormRef;
            let currentObj = this;
            if (!formEl) return
            formEl.validate((valid) => {


                if (valid) {
                    currentObj.addloading=true;
                    loadingInstance = ElLoading.service({ fullscreen: true });
                    axios.post('/users',currentObj.addform).then(function (response) {

                        currentObj.addloading=false;
                        ElMessage({
                            showClose: true,
                            message: 'User Added Succesfully.',
                            type: 'success',
                        });
                        currentObj.adddrawer=false;
                        formEl.resetFields();
                        currentObj.getlist();
                        loadingInstance.close();
                    })
                        .catch(function (error) {
                            currentObj.addloading=false;
                            loadingInstance.close();
                            if( error.response ){
                                currentObj.addformerrors=error.response.data;
                            }

                        });
                } else {

                    return false
                }
            })


        },
        geterror(){
            if(this.addformerrors.errors){
                var errorString = '';
                $.each( this.addformerrors.errors, function( key, value) {
                    errorString = value[0];
                });

               return errorString;
            }
            else{
                return "";
            }

        }
    },
    watch: {
        filterText(val, oldVal) {

            this.$refs.treeRef.filter(val)
        }
    }
}
</script>

<style scoped>

</style>
